import React from "react";
import "./App.css";
import Body from "./Pages/Body/body.js";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Footer from "./Components/Footer/Footer";
import UserWindow from "./Components/screenSize";
import Loginpg from "./Pages/Login";
import PrivateRoute from "./Pages/Protected";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  return (
    <div>
      <Router>
        <Routes>
          <Route exact path="/" element={<Loginpg />} />
          <Route path="/window" element={<UserWindow />} />
          <Route path="/" element={<PrivateRoute />}>
            <Route path="/dashboard" element={<Body />} />
          </Route>
        </Routes>
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </Router>
      <Footer />
    </div>
  );
};

export default App;
